import React, { useEffect, useState } from 'react';
import MainSlider from 'components/generals/main-slider';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo_ptg from 'assets/images/logos/ptg-blue.png';
import logo_hsc from 'assets/images/logos/harbor.webp';
import logo_ptyss from 'assets/images/logos/PTYSS-logo-blue.png';
import { MdArrowForwardIos } from 'react-icons/md';
import Animated from 'components/generals/AnimatedComponent';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import CompaniesBlock from 'components/generals/companies';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css';

export default function PreloadPage() {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const [block, setActiveBlock] = useState('PTG');

    const handleBlock = (block: string) => {
        setActiveBlock(block);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            <main className="main__page main__page--full nv__main__home">
                <Swiper
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    effect={'fade'}
                    loop={true}
                    navigation={false}
                    pagination={{ clickable: true }}
                    speed={1500}
                    modules={[Autoplay, Navigation, Pagination, EffectFade]}
                >
                    <SwiperSlide>
                        <div className="nv__slider__item nv__slider__item--1">
                            <CompaniesBlock />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="nv__slider__item nv__slider__item--2">
                            <CompaniesBlock />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="nv__slider__item nv__slider__item--3">
                            <CompaniesBlock />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="nv__slider__item nv__slider__item--4">
                            <CompaniesBlock />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="nv__slider__item nv__slider__item--5">
                            <CompaniesBlock />
                        </div>
                    </SwiperSlide>
                </Swiper>

                {/*  */}
                {/* <section className="nv__preload__footer__menu">
                <ul className="nv__preload__menu">
                <li className="menu__item">
                <Link to="/ptg">{'PTG'}</Link>
                </li>
                <li className="menu__item">
                <Link to="/harbour">{'HSC'}</Link>
                    </li>
                    <li className="menu__item">
                    <Link to="/ptyss">PTYSS</Link>
                    </li>
                    </ul>
                    </section> */}
            </main>
        </>
    );
}
